import React from "react";

const Reports = () => {
  return <div>Reports - Coming Soon</div>;
};

export default Reports;
